/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, Input, Skeleton } from 'antd';
import React from 'react';

import './style.less';

interface DataItem {
  value: any;
  label: string;
}

interface Props {
  onSearch(value: string): void;
  dataSource?: DataItem[];
  loading: boolean;
  footer?: React.ReactNode;
  onChange(value: any): void;
  value: any;
  dropdownComponent?: (
    Component: React.FC<{ item: DataItem }>,
  ) => React.ReactNode;
}

const ItemList: React.FC<{
  value: any;
  item: DataItem;
  onChange(value: any): void;
}> = (props) => (
  <li className="column-filter-list-item">
    <button
      className="column-filter-list-button"
      data-active={props.item.value === props.value}
      onClick={() => props.onChange(props.item.value)}
    >
      {props.item.label}
    </button>
  </li>
);

const ColumnFilter: React.FC<Props> = (props) => {
  return (
    <Card
      title={
        <Input
          placeholder="Filtrar"
          onChange={({ target }) => props.onSearch(target.value)}
        />
      }
      className="column-filter"
    >
      <Skeleton loading={props.loading}>
        <ul className="column-filter-list">
          {!!props.dropdownComponent &&
            props.dropdownComponent(({ item }) => (
              <ItemList item={item} {...props} />
            ))}

          {!props.dropdownComponent &&
            props.dataSource?.map((item, index) => (
              <ItemList item={item} key={index} {...props} />
            ))}
          <li>
            {!!props.footer && (
              <div className="column-filter-footer">{props.footer}</div>
            )}
          </li>
        </ul>
      </Skeleton>
    </Card>
  );
};

export default ColumnFilter;
